// removed by extract-text-webpack-plugin
module.exports = {"section":"section"};


//////////////////
// WEBPACK FOOTER
// ./components/UI/Form/_SubCategorySelectorInput.scss
// module id = ./components/UI/Form/_SubCategorySelectorInput.scss
// module chunks = 1